export default "__VITE_ASSET__Y0Heq8Sg__"